import { EmployerAgreementsService_employerAgreementServiceGetGetCreateAgreementCommandFrame } from '@festina/life-general-types/life/hooks/EmployerAgreementsCommandsFramesService_employerAgreementServiceGetGetCreateAgreementCommandFrame'

export const useFetchCreateEmployerAgreementFrame =
  EmployerAgreementsService_employerAgreementServiceGetGetCreateAgreementCommandFrame.useSuspenseQuery
